module.exports = __webpack_public_path__ + "img/avatar.76aa1402.png";